import { render } from "./Bridges.vue?vue&type=template&id=4f83b912"
import script from "./Bridges.vue?vue&type=script&lang=js"
export * from "./Bridges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__